import { useState } from 'react'

export const useGuarantorSecondNegativeFeedback = () => {
  const [isShowModal, setIsShowModal] = useState(false)

  return [isShowModal, setIsShowModal]
}
